(() => {
  if (window.__catTreeBackToProductsBound) return;
  window.__catTreeBackToProductsBound = true;

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cat-tree-back-to-products]');
    if (!button) return;

    const target = document.getElementById(button.dataset.target);
    if (!target) return;

    event.preventDefault();
    const scrollMarginTop = Number.parseFloat(window.getComputedStyle(target).scrollMarginTop) || 0;
    let targetTop = 0;
    let offsetParent = target;

    while (offsetParent) {
      targetTop += offsetParent.offsetTop;
      offsetParent = offsetParent.offsetParent;
    }

    const top = Math.max(0, targetTop - scrollMarginTop);

    window.scrollTo({
      top,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  });
})();
